import SignupPage from "../features/signup/SignupPage";

const Signup = () => {
  return <SignupPage />;
};

export default Signup;
